import React, { useEffect, useState, createContext, useContext } from 'react';
import { translations, Language } from './translations';
type LanguageContextType = {
  lang: Language | null;
  setLang: (lang: Language) => void;
  t: (path: string) => any;
};
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export const LanguageProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [lang, setLangState] = useState<Language | null>(null);
  useEffect(() => {
    const savedLang = localStorage.getItem('soyjoha_lang') as Language;
    if (savedLang && (savedLang === 'es' || savedLang === 'en')) {
      setLangState(savedLang);
    }
  }, []);
  const setLang = (newLang: Language) => {
    localStorage.setItem('soyjoha_lang', newLang);
    setLangState(newLang);
  };
  const t = (path: string) => {
    const currentLang = lang || 'es'; // default to es if null
    const keys = path.split('.');
    let result: any = translations[currentLang];
    for (const key of keys) {
      if (result[key] === undefined) {
        console.warn(`Translation key not found: ${path}`);
        return path;
      }
      result = result[key];
    }
    return result;
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-195">
      {children}
    </LanguageContext.Provider>;
};
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};